var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.name)?_c('Attendance',{staticStyle:{"padding":"0","height":"100%"},attrs:{"book":_vm.name}}):_c('a-result',{attrs:{"title":"信息未完善，暂时无法查询考勤记录"}})
}
var staticRenderFns = []

export { render, staticRenderFns }